"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealmWrapper = void 0;
/* eslint-disable node/no-unsupported-features/node-builtins */
const solana_contrib_1 = require("@saberhq/solana-contrib");
const web3_js_1 = require("@solana/web3.js");
const utf8_1 = require("@project-serum/anchor/dist/cjs/utils/bytes/utf8");
const tribeca_sdk_1 = require("@tribecahq/tribeca-sdk");
const gauges_1 = require("./gauges");
const SimpleNftKind_1 = require("./SimpleNftKind");
class RealmWrapper {
    constructor(sdk, address) {
        this.sdk = sdk;
        this.address = address;
        this._data = null;
        this._governor = null;
    }
    get provider() {
        return this.sdk.provider;
    }
    get program() {
        return this.sdk.program;
    }
    async reload() {
        this._data = await this.program.account.realm.fetch(this.address);
        if (!this._governor ||
            !this._governor.governorKey.equals(this._data.governor)) {
            this._governor = new tribeca_sdk_1.GovernorWrapper(this.sdk.tribeca, this._data.governor);
        }
        return this._data;
    }
    async tryReload() {
        this._data = await this.program.account.realm.fetchNullable(this.address);
        if (this._data &&
            (!this._governor ||
                !this._governor.governorKey.equals(this._data.governor))) {
            this._governor = new tribeca_sdk_1.GovernorWrapper(this.sdk.tribeca, this._data.governor);
        }
        return this._data;
    }
    async data() {
        if (!this._data) {
            return await this.reload();
        }
        return this._data;
    }
    async tryData() {
        if (!this._data) {
            return await this.tryReload();
        }
        return this._data;
    }
    async governor() {
        if (!this._governor) {
            await this.reload();
        }
        return this._governor;
    }
    creatorWithBump() {
        return web3_js_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('creator'), this.address.toBytes()], this.program.programId);
    }
    async creator() {
        const [creator] = await this.creatorWithBump();
        return creator;
    }
    electorateWithBump() {
        return web3_js_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('electorate'), this.address.toBytes()], this.program.programId);
    }
    async electorate() {
        const [electorate] = await this.electorateWithBump();
        return electorate;
    }
    collectionAuthorityWithBump() {
        return web3_js_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('collection'), this.address.toBytes()], this.program.programId);
    }
    async collectionAuthority() {
        const [collectionAuthority] = await this.collectionAuthorityWithBump();
        return collectionAuthority;
    }
    async createAccount({ address, rentPayer, }) {
        if (!address.publicKey.equals(this.address)) {
            throw new Error(`Address ${address.publicKey.toBase58()} does not match`);
        }
        const signers = [address];
        if (rentPayer) {
            signers.push(rentPayer);
        }
        return new solana_contrib_1.TransactionEnvelope(this.provider, [
            web3_js_1.SystemProgram.createAccount({
                fromPubkey: (rentPayer === null || rentPayer === void 0 ? void 0 : rentPayer.publicKey) || this.provider.wallet.publicKey,
                newAccountPubkey: address.publicKey,
                lamports: await this.provider.connection.getMinimumBalanceForRentExemption(RealmWrapper.SPACE),
                space: RealmWrapper.SPACE,
                programId: this.program.programId,
            }),
        ], signers);
    }
    async init({ address, admin, governor, govMint, rentPayer, }) {
        const tx = address
            ? await this.createAccount({
                address,
                rentPayer,
            })
            : new solana_contrib_1.TransactionEnvelope(this.provider, []);
        return tx.combine(new solana_contrib_1.TransactionEnvelope(this.provider, [
            await this.program.methods
                .initRealm(admin, govMint)
                .accounts({
                realm: this.address,
                governor,
            })
                .instruction(),
        ], []));
    }
    static async create({ sdk, address = new web3_js_1.Keypair(), admin, governor, govMint, rentPayer, }) {
        const wrapper = new RealmWrapper(sdk, address.publicKey);
        const tx = await wrapper.init({
            address,
            admin,
            governor,
            govMint,
            rentPayer,
        });
        return {
            tx,
            wrapper,
        };
    }
    async setAdmin({ oldAdmin, newAdmin, }) {
        const signers = [];
        if (!oldAdmin) {
            oldAdmin = (await this.data()).admin;
        }
        if (!(oldAdmin instanceof web3_js_1.PublicKey)) {
            signers.push(oldAdmin);
            oldAdmin = oldAdmin.publicKey;
        }
        return new solana_contrib_1.TransactionEnvelope(this.provider, [
            await this.program.methods
                .setAdmin(newAdmin)
                .accounts({
                realm: this.address,
                admin: oldAdmin,
            })
                .instruction(),
        ], signers);
    }
    static async loadAll(sdk) {
        const realms = await sdk.program.account.realm.all();
        return await Promise.all(realms.map(async (account) => {
            const realm = new RealmWrapper(sdk, account.publicKey);
            realm._data = account.account;
            return realm;
        }));
    }
    gaugemeisters() {
        return gauges_1.GaugemeisterWrapper.loadByRealm(this);
    }
    nftKinds() {
        return SimpleNftKind_1.SimpleNftKindWrapper.loadAll(this.sdk, this);
    }
}
exports.RealmWrapper = RealmWrapper;
RealmWrapper.SPACE = 147 + 8 * 32;
//# sourceMappingURL=Realm.js.map